<template>
    <div class="page-404">
      <div class="error-content">
        <!-- 404数字区域 -->
        <div class="error-number">
          <span class="digit">4</span>
          <div class="zero">
            <i class="el-icon-circle-close zero-icon"></i>
          </div>
          <span class="digit">4</span>
        </div>
        
        <!-- 错误信息 -->
        <h1 class="title">Page Not Found</h1>
        <p class="description">
            Sorry, the page you are trying to access may have been deleted, moved, or is temporarily unavailable.
        </p>
        
        <!-- 搜索框 -->
        <!-- <div class="search-box">
          <el-input
            v-model="searchQuery"
            placeholder="搜索您需要的内容..."
            class="search-input"
            @keyup.enter.native="handleSearch"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="handleSearch"
            ></el-button>
          </el-input>
        </div> -->
        
        
        <!-- 底部信息 -->
        <!-- <div class="footer-info">
          <el-divider></el-divider>
          <p class="footer-text">
            如果问题持续存在，请联系我们：
            <el-button type="text" @click="contactSupport">技术支持</el-button>
          </p>
        </div> -->
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Page404',
    data() {
      return {
       
      }
    },
    methods: {
     
    }
  }
  </script>
  
  <style scoped>
  .page-404 {
    min-height: 100vh;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    /* padding: 40px 20px; */
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif;
  }
  
  .error-content {
    max-width: 800px;
    width: 100%;
    background: white;
    border-radius: 20px;
    padding: 50px;
    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  /* 404数字样式 */
  .error-number {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 40px;
    animation: fadeInDown 0.8s ease;
  }
  
  .digit {
    font-size: 160px;
    font-weight: 900;
    color: #409EFF;
    line-height: 1;
    text-shadow: 5px 5px 0 rgba(64, 158, 255, 0.1);
  }
  
  .zero {
    width: 150px;
    height: 150px;
    margin: 0 30px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: rotateZero 15s linear infinite;
  }
  
  .zero-icon {
    font-size: 120px;
    color: #F56C6C;
    animation: pulse 2s ease-in-out infinite;
  }
  
  @keyframes rotateZero {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
  @keyframes pulse {
    0%, 100% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.1);
      opacity: 0.8;
    }
  }
  
  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  /* 标题和描述 */
  .title {
    font-size: 36px;
    color: #303133;
    margin-bottom: 20px;
    font-weight: 600;
    animation: fadeInUp 0.8s ease 0.2s both;
  }
  
  .description {
    font-size: 18px;
    color: #606266;
    margin-bottom: 40px;
    line-height: 1.6;
    animation: fadeInUp 0.8s ease 0.3s both;
  }
  
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  /* 搜索框 */
  .search-box {
    max-width: 500px;
    margin: 0 auto 40px;
    animation: fadeInUp 0.8s ease 0.4s both;
  }
  
  .search-input {
    border-radius: 50px;
    overflow: hidden;
  }
  
  .search-input >>> .el-input__inner {
    border-radius: 50px 0 0 50px;
    border: 2px solid #409EFF;
    border-right: none;
    padding-left: 25px;
    height: 50px;
    font-size: 16px;
  }
  
  .search-input >>> .el-input-group__append {
    border-radius: 0 50px 50px 0;
    background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
    border: 2px solid #409EFF;
    border-left: none;
  }
  
  .search-input >>> .el-input-group__append .el-button {
    color: white;
    font-size: 20px;
    padding: 0 25px;
  }
  
  .search-input >>> .el-input-group__append .el-button:hover {
    background: transparent;
  }
  
  /* 操作按钮 */
  .actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 40px;
    flex-wrap: wrap;
    animation: fadeInUp 0.8s ease 0.5s both;
  }
  
  .action-btn {
    padding: 15px 35px;
    font-size: 16px;
    border-radius: 50px;
    min-width: 160px;
  }
  
  .action-btn.el-button--primary {
    background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
    border: none;
  }
  
  .action-btn.el-button--primary:hover {
    background: linear-gradient(135deg, #337ecc 0%, #2b6cb0 100%);
    transform: translateY(-2px);
    box-shadow: 0 10px 20px rgba(64, 158, 255, 0.3);
  }
  
  /* 快捷链接 */
  .quick-links {
    margin-bottom: 30px;
    animation: fadeInUp 0.8s ease 0.6s both;
  }
  
  .links-title {
    font-size: 18px;
    color: #909399;
    margin-bottom: 15px;
  }
  
  .links-container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 15px;
  }
  
  .link-btn {
    font-size: 16px;
    color: #606266;
    padding: 8px 20px;
  }
  
  .link-btn:hover {
    color: #409EFF;
    transform: translateY(-2px);
  }
  
  .link-btn i {
    margin-right: 8px;
  }
  
  /* 底部信息 */
  .footer-info {
    animation: fadeInUp 0.8s ease 0.7s both;
  }
  
  .footer-text {
    color: #909399;
    font-size: 14px;
  }
  
  /* 响应式设计 */
  @media (max-width: 768px) {
    .error-content {
      padding: 30px 20px;
    }
    
    .digit {
      font-size: 100px;
    }
    
    .zero {
      width: 100px;
      height: 100px;
      margin: 0 20px;
    }
    
    .zero-icon {
      font-size: 80px;
    }
    
    .title {
      font-size: 28px;
    }
    
    .description {
      font-size: 16px;
    }
    
    .actions {
      flex-direction: column;
      align-items: center;
    }
    
    .action-btn {
      width: 100%;
      max-width: 300px;
    }
    
    .links-container {
      flex-direction: column;
      align-items: center;
    }
    
    .link-btn {
      width: 100%;
      max-width: 200px;
      text-align: left;
    }
  }
  </style>